import { FormFieldConfig } from '@shared/components/search-form/search-form.component';
import { TableColumn } from '@shared/components/data-table/data-table.component';

// ============================================================================
// SEARCH FORM CONFIGURATION
// ============================================================================

export interface UserRolesAssignmentSearchOptions {
  roleOptions: { label: string; value: string }[];
  businessUnitOptions: { label: string; value: number }[];
}

/**
 * Build search form config with dynamic dropdown options.
 */
export function getSearchFormConfig(
  options: UserRolesAssignmentSearchOptions,
): FormFieldConfig[] {
  return [
    {
      key: 'firstname',
      label: 'configuration.user_roles_assignment.search.firstname',
      type: 'text',
      placeholder: 'configuration.user_roles_assignment.search.firstname_ph',
      width: '160px',
    },
    {
      key: 'lastname',
      label: 'configuration.user_roles_assignment.search.lastname',
      type: 'text',
      placeholder: 'configuration.user_roles_assignment.search.lastname_ph',
      width: '160px',
    },
    {
      key: 'username',
      label: 'configuration.user_roles_assignment.search.username',
      type: 'text',
      placeholder: 'configuration.user_roles_assignment.search.username_ph',
      width: '160px',
    },
    {
      key: 'email',
      label: 'configuration.user_roles_assignment.search.email',
      type: 'text',
      placeholder: 'configuration.user_roles_assignment.search.email_ph',
      width: '200px',
    },
    {
      key: 'role',
      label: 'configuration.user_roles_assignment.search.roles',
      type: 'select',
      options: options.roleOptions,
      showClear: true,
      width: '200px',
    },
    {
      key: 'businessUnitId',
      label: 'configuration.user_roles_assignment.search.business_unit',
      type: 'select',
      options: options.businessUnitOptions,
      showClear: true,
      width: '220px',
    },
  ];
}

// ============================================================================
// TABLE COLUMN CONFIGURATION
// ============================================================================

export const USER_ROLES_ASSIGNMENT_DEFAULT_COLUMNS: TableColumn[] = [
  {
    label: 'configuration.user_roles_assignment.table.employee_id',
    prop: 'employeeId',
    width: 120,
    sortable: true,
  },
  {
    label: 'configuration.user_roles_assignment.table.firstname',
    prop: 'firstName',
    width: 120,
    sortable: true,
  },
  {
    label: 'configuration.user_roles_assignment.table.lastname',
    prop: 'lastName',
    width: 120,
    sortable: true,
  },
  {
    label: 'configuration.user_roles_assignment.table.username',
    prop: 'username',
    width: 140,
    sortable: true,
  },
  {
    label: 'configuration.user_roles_assignment.table.email',
    prop: 'email',
    width: 200,
  },
  {
    label: 'configuration.user_roles_assignment.table.business_unit',
    prop: 'businessUnitDisplay',
    width: 180,
  },
  {
    label: 'configuration.user_roles_assignment.table.roles',
    prop: 'rolesDisplay',
    width: 220,
  },
];

export const USER_ROLES_ASSIGNMENT_FLEXIBLE_COLUMNS: TableColumn[] = [];
